import { Link } from 'react-router';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import MuiListItemText from '@mui/material/ListItemText';
import MuiListItemIcon from '@mui/material/ListItemIcon';
import { TypographyProps } from '@mui/material/Typography';
import classNames from 'classnames';
import ListItemButton from '@mui/material/ListItemButton';

interface IProps {
  to: string;
  text: React.ReactNode;
  icon?: React.ReactElement<any>;
  children?: React.ReactNode;
  type?: string;
  typographyProps?: TypographyProps<'span', { component?: 'span' }>;
  inset?: boolean;
  testId?: string;
  classes?: Partial<Record<keyof ReturnType<typeof styles>, string>>;
}

const styles = (theme: Theme) => ({
  rootListItemText: {
    paddingLeft: theme.spacing(1),
  },
  root: {
    textDecoration: 'none',
  },
  light: {
    color: theme.customProperties.Fade.DarkOnLight.highEmphasis,
  },
  dark: {
    color: theme.customProperties.Fade.LightOnDark.highEmphasis,
    '& h3, & span': {
      color: theme.customProperties.Fade.LightOnDark.highEmphasis,
    },
  },
  inset: {
    '&:first-of-type': {
      paddingLeft: theme.spacing(6.25),
    },
  },
  gutters: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(3),
  },
  icon: {},
  listItem: {},
});

const EDLinkListItem: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = (props: IProps) => {
  const colorClass =
    props.type === 'dark' ? props.classes?.dark : props.classes?.light;

  return (
    <Link to={props.to} className={props.classes?.root} type={props.type}>
      <ListItemButton
        className={classNames(colorClass, props.classes?.listItem)}
        classes={{ gutters: props.classes?.gutters }}
        data-testid={props.testId}
      >
        {props.icon && (
          <MuiListItemIcon
            className={classNames(colorClass, props.classes?.icon)}
          >
            {props.icon}
          </MuiListItemIcon>
        )}
        <MuiListItemText
          primary={props.text}
          primaryTypographyProps={props.typographyProps}
          inset={props.inset}
          classes={{
            inset: props.classes?.inset,
            root: props.classes?.rootListItemText,
          }}
          className={colorClass}
        />
        {props.children}
      </ListItemButton>
    </Link>
  );
};

export default withStyles(EDLinkListItem, styles);
